import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import React, { useEffect, useState } from "react";
import { getValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import ScrollableDataTable from "@components/ScrollableDatatable/index";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import Notfound from "@components/Not-Found";
import Loader from "@components/common/Loader";
import { useParams } from "react-router-dom";
import { formatText } from "@_common/format-text";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import { NavLink } from "react-router-dom";
import {
	NewDate,
	convertCurrentDate,
	convertCurrentDateWithTime,
	convertDate,
} from "@_common/date-helpers";
import {
	UpdateSelfComplianceTask,
	getSpecificSelfComplianceTaskHistory,
} from "@services/self-compliance.service";
import SelfComplianceTaskNavigation from "@components/Tasks/task-self-compliance-navigation";
import NavigationBar from "@components/NotificationBar";
import { clientAdminFileUpload } from "@services/client-list.service";
import { toast } from "react-toastify";
import InputField from "@_common/InputRuleFeild";
import DragAndDropFileComponent from "@_common/file-drag-drop";
import UpdateTaskPopup from "../UpdateTaskPopup";
import { tableStatusStyle } from "@_common/colors";
import { getEntityGroups } from "@services/entity-mapping.service";
import { getSpecificCategoryLawById } from "@_common/global-apis";
import { sanitizeInput } from "@_common/dompurify";

interface IComplianceTaskHistoryProps {}

const ComplianceAuditTaskHistoryPage: React.FunctionComponent<
	IComplianceTaskHistoryProps
> = (props: any) => {
	let navigate = useNavigate();
	let mainParams = useParams();

	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */

	const [isLoading, setIsLoading] = React.useState(true);
	const [list, setList] = React.useState<[]>([]);
	const [isFilterVisible, setFilterVisibility] = React.useState(false);

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
			getData();
		}
	}, [props.permissionAPITriggered]);

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
			getData();
			if (params.page_no) {
				setPage_no(parseInt(params.page_no));
			}
			if (params.search_text) {
				setSearchInput(params.search_text);
				setShowSearchTextbox(true);
			}
			if (params.limit) {
				setLimit(parseInt(params.limit));
			}
		}
	}, [window.location.href, props.permissionAPITriggered]);

	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */
	const [licenseIDs, setLicenseIDs] = useState([]);
	const getData = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		// let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
		// let dates = params.date ? new Date(params.date) : new Date();
		// var from_date = params.from_date
		// 	? params.from_date
		// 	: new Date(dates.getFullYear(), dates.getMonth(), 1);
		// var to_date = params.to_date
		// 	? params.to_date
		// 	: new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

		//entity mapping
		let obj: any = {};
		let response = await getEntityGroups("");
		if (response) {
			getValue(response, `data.entityGroups`, []).map((item: any) => {
				return (obj[`level_${getValue(item, `group_level`, "")}`] = getValue(
					item,
					`id`,
					""
				));
			});
		}

		let payload: any = {
			// from_date: convertDate(from_date),
			// to_date: convertDate(to_date),
			page_no: params.page_no ? parseInt(params.page_no) : 1,
			page_size: params.limit ? parseInt(params.limit) : limit,
			search_text: params.search_text,
			checkpoint_id: mainParams.checkpoint_id,
			sort_by: params.sort_by,
			country_id: parseInt(getValue(params, `country_id`, "")),
			state_id: parseInt(getValue(params, `state_id`, "")),
			category_of_law_id: await getSpecificCategoryLawById(
				getValue(params, `category_of_law_id`, "")
			  ),
			legislation_id: getValue(params, `legislation_id`, ""),
			legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
			event_id: parseInt(getValue(params, `event_id`, "")),
			sub_event_id: parseInt(getValue(params, `sub_event_id`, "")),
			compliance_type_id: getValue(params, `compliance_type_id`, ""),
			// request_from: "MY_TASKS",
		};
		Object.keys(payload).forEach((key) => {
			if (!payload[key] || payload[key] === undefined) {
				delete payload[key];
			}
		});
		//finding only levels params if it presented in URL
		let queryRequest = QueryRequestHelper({ ...payload, ...obj });
		try {
			setIsLoading(true);
			let resp = await getSpecificSelfComplianceTaskHistory(
				mainParams.id,
				queryRequest
			);
			if (resp) {
				setList(
					getValue(resp, `data.task_history`, []).map((item: object) => ({
						...item,
						task_id: getValue(item, `task_id`, ""),
						category_of_lawName: getValue(item, `category_of_law.text`, ""),
						compliance_typeName: getValue(item, `compliance_type.text`, ""),
						frequencyName: getValue(
							item,
							`self_compliance.checkpoint.frequency.text`,
							""
						),
						compliance_activity: getValue(item, `compliance_activity`, ""),
						legislationName: getValue(
							item,
							`self_compliance.checkpoint.legislation.legislation_name`,
							""
						),
						reference: getValue(
							item,
							`self_compliance.checkpoint.reference`,
							""
						),
						who: getValue(item, `self_compliance.checkpoint.who`, ""),
						when: getValue(item, `self_compliance.checkpoint.when`, ""),
						frequency: getValue(
							item,
							`self_compliance.checkpoint.frequency.text`,
							""
						),
						legislation_ruleName: getValue(
							item,
							`self_compliance.checkpoint.legislation_rule.rule_name`,
							""
						),
						activation_status: formatText(
							getValue(item, `self_compliance.activation_status`, "")
						),
						compliance_status_formatted: formatText(
							getValue(item, `compliance_status`, "")
						),
						work_status_formatted: formatText(
							getValue(item, `work_status`, "")
						),
						configure: getValue(item, `is_configured`, "")
							? "Configured"
							: "Not Configured",
						legal_due_date: convertCurrentDate(
							getValue(item, `legal_due_date`, "")
						),
						created_at: convertCurrentDateWithTime(
							getValue(item, `created_at`, "")
						),

						owner_due_date_main: convertCurrentDate(
							getValue(item, `owner_due_date`, "")
						),
						approver_due_date_main: convertCurrentDate(
							getValue(item, `approver_due_date`, "")
						),
						function_head_due_date_main: convertCurrentDate(
							getValue(item, `function_head_due_date`, "")
						),
						unit_head_due_date_main: convertCurrentDate(
							getValue(item, `unit_head_due_date`, "")
						),
						executor_name:
							formatText(getValue(item, `executor.first_name`, "")) +
							" " +
							formatText(getValue(item, `executor.last_name`, "")),
					}))
				);
				let licenseIDs = getValue(resp, `data.checkpoints`, []).filter(
					(item: object) =>
						getValue(item, `compliance_type.text`, "") === "License"
				);
				setLicenseIDs(
					getValue(licenseIDs, `length`, 0) > 0
						? licenseIDs.map((item: any) => item.id)
						: []
				);
				setTotalCount(getValue(resp, `data.pagination.total`, 0));
				setIsLoading(false);
			} else {
				setIsLoading(false);
			}
		} catch (error) {
			setIsLoading(false);
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Search section                               */
	/* -------------------------------------------------------------------------- */
	const [showSearchTextbox, setShowSearchTextbox] = useState(false);
	const [search_text, setSearchInput] = useState<any>("");

	const toggleSearch = () => {
		setShowSearchTextbox((prevState) => !prevState);
	};
	const toggleSearchClose = () => {
		setSearchInput("");
		toggleSearch();
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (params.search_text) {
			delete params.search_text;
			let payload: any = { ...params };
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
			getData();
		}
	};

	const handleChangeSearch = async (e: any) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		setSearchInput(e.target.value);

		let payload: any = {
			...params,
			page_no:1,
			search_text: e.target.value,
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
		if (!e.target.value) {
			getData();
		}
	};

	const [selectedIDs, setSelectedIDs] = useState<any>([]);
	const getTableState = (value: object) => {
		let selectedIndexList = Object.keys(
			getValue(value, `selectedRowIds`, {})
		).map((item) => parseInt(item));
		let selectedIds =
			list.length > 0
				? list.filter((_item: object, index: number) =>
						selectedIndexList.includes(index)
				  )
				: [];
		if (selectedIds.length > 0) {
			setSelectedIDs(
				selectedIds.map((item: object) => getValue(item, `id`, ""))
			);
		} else {
			setSelectedIDs([]);
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Pagination section                           */
	/* -------------------------------------------------------------------------- */

	const [totalCount, setTotalCount] = useState(0);
	const [limit, setLimit] = useState(10);
	const [page_no, setPage_no] = useState(1);

	const handleChangePagination = (page_no: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload = {
			...params,
			page_no: page_no,
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	const handleChangeLimit = (limit: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload: any = {
			...params,
			limit: limit,
			page_no: "1",
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	const [selectedId, setSelectedId] = useState("");
	const rowClick = (obj: object) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload: any = {
			...params,
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(
			`/${route[1]}/${route[2]}/${route[3]}/task-details/${getValue(
				obj,
				`original.id`,
				""
			)}/${mainParams.checkpoint_id}?${queryRequest}`
		);
	};
	const handleClickPopup = (obj: object) => {
		setShowUpdatePopup(!showUpdatePopup);
		setSelectedId(getValue(obj, `original.id`, ""));
		setSelfCompliance({
			...selfCompliance,
			completion_date: NewDate(getValue(obj, `original.completion_date`, null)),
			compliance_status: getValue(obj, `original.compliance_status`, null),
			work_status: getValue(obj, `original.work_status`, null),
			remarks: getValue(obj, `original.remarks`, null),
			non_compliance_reason: getValue(
				obj,
				`original.non_compliance_reason`,
				null
			),
			event_not_occured: getValue(obj, `original.event_not_occured`, false),
			document_ids: getValue(obj, `original.documents`, []),
		});
	};

	const columns = React.useMemo(
		() => [
			{
				Header: "Task ID",
				accessor: "task_id",
				width: 150,
				Cell: ({ row }: any) => {
					return (
						<NavLink to={`#`}>{getValue(row, `original.task_id`, "")}</NavLink>
					);
				},
			},
			{
				Header: "Executor ",
				accessor: "executor_name",
				width: 150,
			},

			{
				Header: "Executor Date",
				accessor: "owner_due_date_main",
				width: 150,
			},
			{
				Header: "Evaluator Date",
				accessor: "approver_due_date_main",
				width: 150,
			},
			{
				Header: "Function Head Date",
				accessor: "function_head_due_date_main",
				width: 150,
			},
			// {
			// 	Header: "Unit Head Date",
			// 	accessor: "unit_head_due_date_main",
			// 	width: 150,
			// },
			{
				Header: "Legal Date",
				accessor: "legal_due_date",
				width: 150,
			},
			{
				Header: "Legislation",
				accessor: "legislationName",
				width: 250,
			},
			{
				Header: "Rule",
				accessor: "legislation_ruleName",
				width: 250,
			},
			{
				Header: "Reference",
				accessor: "reference",
				width: 250,
			},
			// {
			// 	Header: "Who",
			// 	accessor: "who",
			// 	width: 250,
			// },
			// {
			// 	Header: "When",
			// 	accessor: "when",
			// 	width: 250,
			// },

			// {
			// 	Header: "Frequency",
			// 	accessor: "frequency",
			// 	width: 250,
			// },

			{
				Header: "Activation Status",
				accessor: "activation_status",
				width: 150,
			},

			{
				Header: "Compliance Status",
				accessor: "compliance_status_formatted",
				width: 150,
			},

			{
				Header: "Created Date",
				accessor: "created_at",
				width: 150,
			},
			// {
			// 	Header: "Action",
			// 	width: 250,
			// 	Cell: ({ row }: any) => {
			// 		return (
			// 			<>
			// 				<Button
			// 					color="primary"
			// 					onClick={() => handleEdit(row.original.id)}
			// 				>
			// 					Edit
			// 				</Button>
			// 				&nbsp;&nbsp;&nbsp;
			// 				<Button
			// 					color="danger"
			// 					onClick={() =>
			// 						handleDeleteFun(row.original.id, row.values.checkpoint_id)
			// 					}
			// 				>
			// 					Delete
			// 				</Button>
			// 			</>
			// 		);
			// 	},
			// },
		],
		[]
	);
	const getTrProps = (rowInfo: any) => {
		if (getValue(rowInfo, `id`, "")) {
			return {
				style: tableStatusStyle(getValue(rowInfo, `compliance_status`, "")),
			};
		}
		return {};
	};
	/* -------------------------------------------------------------------------- */
	/*                                 Update Popup                               */
	/* -------------------------------------------------------------------------- */

	const [selfCompliance, setSelfCompliance] = useState<any>({
		completion_date: "",
		compliance_status: "",
		work_status: "",
		remarks: "",
		non_compliance_reason: "",
		event_not_occured: false,
		document_ids: [],
	});

	const [complianceStatusList] = useState([
		{ value: "PENDING", label: "Pending" },
		{ value: "WORK_IN_PROGRESS", label: "Work In Progress" },
		{ value: "COMPLIED", label: "Complied" },
		{ value: "NON_COMPLIED", label: "Non Complied" },
		{ value: "NOT_APPLICABLE", label: "Not Applicable" },
		{ value: "PARTIALLY_COMPLIED", label: "Partially Complied" },
	]);

	const handleUploadDocuments = async (e: any) => {
		Array.from(e).forEach(async (item: any) => {
			let formData = new FormData();
			formData.append("file", item);
			try {
				let resp = await clientAdminFileUpload(formData);
				if (resp) {
					getValue(selfCompliance, `document_ids`, "").push(
						getValue(resp, `data`, {})
					);

					setSelfCompliance({ ...selfCompliance });
					e = null;
				} else {
					e = null;
				}
			} catch (error) {
				e = null;
			}
		});
	};
	const fileTypes = ["PDF", "JPEG", "XLSX", "CSV", "XLSM", "XLX", "JPG", "PNG"];
	const [submitLoading, setSubmitLoading] = useState(false);
	const handleSubmitTask = async () => {
		try {
			setSubmitLoading(true);
			let resp = await UpdateSelfComplianceTask(selectedId, selfCompliance);
			if (resp) {
				toast.success(getValue(resp, `message`, ""));
				setSubmitLoading(false);
				setShowUpdatePopup(false);
				setSelfCompliance({
					...selfCompliance,
					completion_date: "",
					compliance_status: "",
					work_status: "",
					remarks: "",
					non_compliance_reason: "",
					event_not_occured: false,
					document_ids: [],
				});
				setSelectedId("");
			} else {
				setSubmitLoading(false);
			}
		} catch (error) {
			setSubmitLoading(false);
		}
	};

	/* ---------------------------  Update Modal  ----------------------------- */

	const [showUpdatePopup, setShowUpdatePopup] = useState(false);

	const urlSearchParams = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(urlSearchParams.entries());
	const getSpecificPermissions = (permission: string) => {
		switch (permission) {
			case "my-task":
				return "activities_pe_compliance";
			case "pending-approval":
				return "activities_self_compliance_evaluator_approval";
			case "approved-task":
				return "activities_self_compliance_completed_task";
			case "master":
				return "repository_mapped_checkpoint_master";
			case "function-head":
				return "repository_mapped_checkpoint_function_head";
			case "evaluator":
				return "repository_mapped_checkpoint_evaluator";
			case "pending-audit":
				return "audit_compliance_audit_pending";
			case "completed-audit":
				return "audit_compliance_audit_completed";
			default:
				return null;
		}
	};
	let route = window.location.pathname.split("/");

	return (
		<div className="master-inner-details-grey-bg">
			<Layout>
				{!isLoading &&
				!getValue(props, `subTabPermissionList`, []).includes(
					getSpecificPermissions(route[3])
				) ? (
					<NoAccessPage />
				) : (
					<>	
						<div className="master-details-page-main">	
							<SelfComplianceTaskNavigation
								id={mainParams.id}
								checkpoint_id={mainParams.checkpoint_id}
								permissions={props.permissions}
								global_route={route[1]}
								parent_route={route[2]}
								main_route={route[3]}
								//search
								isTaskHistorySearch={true}
								isSearch={true}
								searchInput={search_text}
								showSearchTextbox={showSearchTextbox}
								toggleSearch={toggleSearch}
								toggleSearchClose={toggleSearchClose}
								handleChangeSearch={handleChangeSearch}
							/>
							{getValue(selectedIDs, `length`, 0) > 0 && (
								<NavigationBar
									selectedIDs={selectedIDs}
									text={"MARK INACTIVE"}
									permissions={props.permissions}
									licenseIDs={licenseIDs}
									// assignTask
									masterNav={"false"}
									isUpdateTaskVisible={
										getValue(selectedIDs, `length`, 0) === 1 ? true : false
									}
								/>
							)}
							<div className="main-page-layout-wrapper">
								<div className="admin-wrapper position-relative">
									<div className="admin-wrapper position-relative d-none">
										<SearchHeader
											route={"/configuration/vendors/add"}
											searchInput={search_text}
											showSearchTextbox={showSearchTextbox}
											toggleSearch={toggleSearch}
											toggleSearchClose={toggleSearchClose}
											handleChangeSearch={handleChangeSearch}
											isBulkUploadVisible={false}
											smartFilter={false}
											setFilterFormVisibility={() => {
												setFilterVisibility(!isFilterVisible);
											}}
											isFilterVisible={isFilterVisible}
											add="false"
										/>
									</div>

									{isLoading || !props.permissionAPITriggered ? (
										<Loader />
									) : list.length > 0 ? (
										<ScrollableDataTable
											columns={columns}
											data={list}
											getTableState={getTableState}
											rowClick={rowClick}
											check={true}
											selectedIDs={selectedIDs}
											getTrProps={getTrProps}
										/>
									) : (
										<>
											{Object.keys(params).length !== 0 ? (
												<>
													<Notfound />
												</>
											) : (
												<Notfound />
											)}
										</>
									)}
								</div>
								<div className="footer-wrapper d-flex justify-content-between">
									{list.length > 0 && (
										<img
											src="/images/building-illustration.svg"
											className="img-fluid"
										/>
									)}
									{totalCount > 10 ? (
										<PaginationPage
											totalCount={totalCount}
											limit={limit}
											pageNumber={page_no}
											handleChangePagination={handleChangePagination}
											handleChangeLimit={handleChangeLimit}
										/>
									) : (
										<p className="show-rows-count mt-3 d-flex">
											Total Count:&nbsp;&nbsp;{" "}
											<p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
										</p>
									)}
								</div>
							</div>
						</div>
					</>
				)}
				{/* complete task popup */}
				<div
					className={`compelte-task-wrapper ${
						showUpdatePopup ? "compelte-task-wrapper--active" : ""
					}`}
				>
					<div className="compelte-task-wrapper__header d-flex align-items-center justify-content-between">
						<h6 className="compelte-task-wrapper__title">Complete Task</h6>
						<img
							src="/images/close-white.svg"
							className="img-fluid navigation-bar-wrapper__close-btn"
							onClick={() => {
								setShowUpdatePopup(false);
							}}
						/>
					</div>
					<div className="compelte-task-wrapper__body d-flex">
						<div className="compelte-task-wrapper__completion flex-2">
							<div className="compelte-task-wrapper__common-header">
								<h5 className="compelte-task-wrapper__common-title">
									Task Completion
								</h5>
							</div>
							<div className="compelte-task-wrapper__form">
								<div className="compelte-task-wrapper__form-group">
									<div className="form-group cursor-pointer grid mt-2">
										<div className="position-relative input-grid-item">
											<label className="compelte-task-wrapper__label">
												Completion Date
											</label>
											<label onClick={(e) => e.preventDefault()}>
												<InputField
													inputType="DATETYPE-DOB-MODAL"
													value={getValue(selfCompliance, `completion_date`, "")}
													className="form-control"
													onChange={(e: any) =>
														setSelfCompliance({
															...selfCompliance,
															completion_date: e,
														})
													}
													minDate={new Date()}
													placeholderText={"Enter Completion Date"}
													disabled
												/>
												<img
													src="/images/calander.svg"
													className="img-fluid form-image form-image--calender-modal"
												/>
											</label>
										</div>
									</div>
									<div className="d-flex mt-3 gap position-relative">
										<label>
											<input
												type="checkbox"
												className="default-checkbox"
												checked={getValue(selfCompliance, `event_not_occured`, "")}
												onChange={(e: any) =>
													setSelfCompliance({
														...selfCompliance,
														event_not_occured: !getValue(
															selfCompliance,
															`event_not_occured`,
															""
														),
													})
												}
											/>
											<div className="custom-checkbox">
												<img
													src="/images/uploaded-details/tick.svg"
													className="upload-tick img-fluid"
												/>
											</div>
										</label>
										<p>Event did not occur</p>
									</div>
								</div>
								<div className="compelte-task-wrapper__form-group">
									<label className="compelte-task-wrapper__label">Remarks</label>
									<textarea
										placeholder="Remarks"
										className="w-100 compelte-task-wrapper__text-area"
										rows={5}
										value={getValue(selfCompliance, `remarks`, "")}
										onChange={(e: any) =>
											setSelfCompliance({
												...selfCompliance,
												remarks: sanitizeInput(e.target.value),
											})
										}
									></textarea>
								</div>
								<div className="compelte-task-wrapper__form-group">
									<label className="compelte-task-wrapper__label">
										Reason for Non-Compliance
									</label>
									<textarea
										placeholder="Enter Reason for Non-Compliance"
										className="w-100 compelte-task-wrapper__text-area"
										rows={5}
										value={getValue(selfCompliance, `non_compliance_reason`, "")}
										onChange={(e: any) =>
											setSelfCompliance({
												...selfCompliance,
												non_compliance_reason: sanitizeInput(e.target.value),
											})
										}
									></textarea>
								</div>
								<div className="compelte-task-wrapper__form-group">
									<DragAndDropFileComponent
										uploadFile={handleUploadDocuments}
										name="file"
										types={fileTypes}
										multiple
										classes="bulk-upload_drag-n-drop-wrapper position-absolute"
										fileName={getValue(props, `importedFile.name`, "")}
										setImportTedFile={props.setImportTedFile}
									/>
									<div className="compelte-task-wrapper__uploaded-files">
										<ul>
											{getValue(selfCompliance, `document_ids`, []).map(
												(item: any, key: number) => {
													return (
														<li className="compelte-task-wrapper__uploaded d-flex align-items-center justify-content-between">
															<span>Billing_Date.pdf</span>
															<img src="/images/close-black.svg" />
														</li>
													);
												}
											)}
										</ul>
									</div>
								</div>
							</div>
							<div className="compelte-task-wrapper__cta d-flex align-items-center gap">
								<button
									className="ascent-button ascent-button--primary"
									onClick={() => setShowUpdatePopup(false)}
								>
									Cancel
								</button>
								<button
									className="ascent-button ascent-button--secondary"
									onClick={handleSubmitTask}
									disabled={submitLoading}
								>
									{submitLoading ? "Please wait..." : "Submit"}
								</button>
							</div>
						</div>
						<div className="compelte-task-wrapper__response flex-1">
							<div className="compelte-task-wrapper__common-header">
								<h5 className="compelte-task-wrapper__common-title">
									Task Responses
								</h5>
							</div>
							<div className="compelte-task-wrapper__form ">
								<div className="grid">
									<div className="compelte-task-wrapper__form-group input-grid-item">
										<InputField
											inputType="INPUT_REACT_SELECT_MODAL"
											placeholder="Enter Compliance Status"
											className="form-control w-100"
											name="compliance_status"
											id="compliance_status"
											value={complianceStatusList.filter(
												(item) =>
													item.value ===
													getValue(selfCompliance, `compliance_status`, "")
											)}
											options={complianceStatusList}
											onChange={(e: any) =>
												setSelfCompliance({
													...selfCompliance,
													compliance_status: e.value,
												})
											}
											label="Compliance Status"
											disabled
										/>
									</div>
								</div>
								<div className="compelte-task-wrapper__form-group">
									<label className="compelte-task-wrapper__label">Remarks</label>
									<p>No remark found</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Layout>
		</div>
	);
};

export default ComplianceAuditTaskHistoryPage;
